import { IconButton } from "@mui/material";
import { closeSnackbar, useSnackbar } from "notistack";
import CancelIcon from '@mui/icons-material/Cancel';

const useNotiStack = () => {
  const { enqueueSnackbar } = useSnackbar();
  const autoHideDuration = 3000;

  const toastSuccess = (msg) => {
   
    enqueueSnackbar(msg, {
      variant: "success",
      autoHideDuration,
    });
  };

  const toastWarning = (msg) => {
    enqueueSnackbar(msg, {
      variant: "warning",
      autoHideDuration,
    });
  };

  const toastInfo = (msg) => {
    enqueueSnackbar(msg, {
      variant: "info",
      // autoHideDuration,
      autoHideDuration: 6000,
    });
  };

  const toastError = (msg) => {
    enqueueSnackbar(msg, {
      variant: "error",
      autoHideDuration: 6000,
      hideIconVariant: true, 
      action: (key) => (
        <IconButton size="small" onClick={() => closeSnackbar(key)}>
      <CancelIcon sx={{color: "white"}} />
        </IconButton>
      ),
    });
  };

  return { toastSuccess, toastWarning, toastInfo, toastError };
};

export default useNotiStack;
